import { useCallback } from "react";
import Swal from "sweetalert2";
import request from "../API";
import { construirQuery } from "../QueryString";
import { descargarBase64ComoBlob, MIME_EXCEL } from "../DescargarArchivo";

// Hook reutilizable para descargar reportes Excel que el backend regresa como
// { documento (base64), filename }.
// Fecha de creación: 2026-09-15 — Autor: IA (Claude)
const MENSAJE_GENERICO =
  "No fue posible generar el archivo. Intente nuevamente o contacte al administrador.";

export const useDescargaExcel = (tituloAlerta, setLoader) => {
  return useCallback(
    (endpoint, parametros = {}, nombrePorDefecto = "REPORTE") => {
      const mostrar = (valor) => setLoader && setLoader((prev) => ({ ...prev, mostrar: valor }));
      mostrar(true);
      return request
        .get(`${endpoint}${construirQuery(parametros)}`)
        .then((result) => {
          if (!result?.documento) {
            Swal.fire(tituloAlerta, "No se generó el archivo. Intente nuevamente.", "warning");
            return;
          }
          descargarBase64ComoBlob(result.documento, `${result.filename || nombrePorDefecto}.xlsx`, MIME_EXCEL);
        })
        .catch((error) => {
          const mensaje = typeof error?.mensaje === "string" && error.mensaje.trim() ? error.mensaje : MENSAJE_GENERICO;
          Swal.fire(tituloAlerta, mensaje, "error");
        })
        .finally(() => mostrar(false));
    },
    [tituloAlerta, setLoader]
  );
};
